import { Button, Image } from "react-bootstrap";

import { Lightbox } from "components/Lightbox";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { dismissInvalidToken, selectInvalidToken } from "store/slices/invalidToken";
import { selectToken, setToken } from "store/slices/token";

import { getFromLocalStorage, saveToLocalStorage } from "utils/localStorage";

import { ACCESS_TOKEN_PARAM } from "const";

// AIDEV-NOTE: „Rozumím“, křížek, Escape i klik mimo dělají totéž — smažou studentský token
// z localStorage i ze storu, takže se aplikace bez reloadu přepne na NotAuthenticated. Obojí
// je potřeba: App větví podle storu, ale Authenticator (nad ním) čte token z localStorage při
// renderu. Nejdřív localStorage, ať ho Authenticator při překreslení po změně storu už nevidí.
// Mazání tokenu rovnou při neplatné odpovědi by naopak nechalo studenta bez vysvětlení. [TD-460]
const InvalidTokenModal = () => {
  const dispatch = useAppDispatch();
  const invalidToken = useAppSelector(selectInvalidToken);
  const token = useAppSelector(selectToken);

  const logOut = () => {
    // AIDEV-NOTE: localStorage sdílejí všechny záložky prohlížeče. Když se student mezitím znovu
    // přihlásil (jiná záložka přepsala token), cizí token nemažeme, jinak bychom odhlásili
    // novější záložku; tuhle odhlásí store. [TD-460]
    if (getFromLocalStorage<string>(ACCESS_TOKEN_PARAM) === token) saveToLocalStorage(ACCESS_TOKEN_PARAM);
    dispatch(setToken(null));
    dispatch(dismissInvalidToken());
  };

  return (
    <Lightbox show={invalidToken === "shown"} onHide={logOut} bodyTitleId="invalid-token-title">
      <div className="d-flex justify-content-center">
        <Image src="/images/capy-question.svg" alt="" style={{ width: "140px" }} />
      </div>
      <div className="text-center mb-5">
        <h2 id="invalid-token-title" className="fs-18">
          Jste přihlášeni jinde
        </h2>
        <p>
          Vypadá to, že jste se do aplikace přihlásili na jiném zařízení nebo v jiném okně prohlížeče. Aplikace může být
          otevřená vždy jen na jednom místě, proto tady nemůžete pokračovat. Váš poslední krok se neuložil.
        </p>
      </div>
      <Button className="w-100" onClick={logOut}>
        Rozumím
      </Button>
    </Lightbox>
  );
};

export default InvalidTokenModal;
